/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.BaseAreaResponseDto>>;
export function request(params: API.basics.baseArea.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/baseArea/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
